import { setupWorker } from "msw/browser";

import {
  customHandlers,
  demoOnlyHandlers,
} from "@vega-api/custom/msw/handlers/handlers";
import { genHandlers } from "@vega-api/extended/genhandlers";

export const worker = setupWorker(
  ...demoOnlyHandlers,
  ...customHandlers,
  ...genHandlers,
);
